const ContactActivity = () => {
    // Personal Information content
    return <div>Contact Stats</div>;
  };

  export default ContactActivity;